/**
 * Подключаем модули локализации
 */

export default (context) => {
  const contextKeys = context.keys();
  const contextValues = contextKeys.map(context);
  return contextKeys.reduce((acc, key, index) => {
    const name = key.replace(/.*\/|\.[^.]*$/g, '');
    const value = contextValues[index]?.default || {};
    return Object.keys(value).reduce((locales, locale) => {
      const localeValues = locales[locale] || {};
      const moduleValues = value[locale];
      return {
        ...locales,
        [locale]: {
          ...localeValues,
          [name]: moduleValues,
        },
      };
    }, acc);
  }, {});
};
